/**
*
* Select
*
*/

import React from 'react';
import { SingleDatePicker, DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import {
  Wrapper,
  Label
} from './styledComponents';
import Icon from 'components/Icon'
import moment from 'moment';

const confirmDate = (date) => {
  const tempDate = Object.assign({}, date);
  return (
    moment(tempDate).startOf('day').isSame(moment().startOf('day')) ?
      confirm("You are about to activate this channel now. You won't be able to edit the event date after you activate the channel. Are you sure you want to activate the channel for today? Click cancel to change your event date") :
      undefined
  );
}

class Date extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      focused: undefined,
      date: props.date,
    };

    this.onFocusChange = this.onFocusChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    this.setState({ date: this.props.date });
  }

  onFocusChange(focusedInput) {
    this.setState({ focused: this.props.isDateRangeMode ? focusedInput : focusedInput.focused });
  }

  onDateChange(date) {
    this.setState({ date });
    this.props.input.onChange(date);
    confirmDate(date);
  }

  onDateRangeChange = (dates) => {
    this.props.input.onChange(dates);
  }

  render() {
    const {
      labelClassName,
      label,
      placeholder,
      required,
      disabled,
      containerClass,
      isDateRangeMode,
      input,
      customArrowIcon,
    } = this.props;

    const {
      focused,
      date,
    } = this.state

    return (
      <Wrapper
        innerRef={ref => this.refArea = ref}
        className={containerClass ? containerClass : ''}>
        {isDateRangeMode
          ? (
            <DateRangePicker
              startDate={input.value ? input.value.startDate : null}
              startDateId={`${input.name}_start_date`}
              endDate={input.value ? input.value.endDate : null}
              endDateId={`${input.name}_end_date`}
              onDatesChange={this.onDateRangeChange}
              focusedInput={focused}
              onFocusChange={this.onFocusChange}
              disabled={disabled}
              required={required}
              screenReaderInputMessage={''}
              displayFormat='MM/DD/YYYY'
              hideKeyboardShortcutsPanel={true}
              customArrowIcon={customArrowIcon}
              isOutsideRange={() => false}
            />
          )
          : ([
            <SingleDatePicker
              key="single_date_picker"
              date={date}
              onDateChange={this.onDateChange}
              onFocusChange={this.onFocusChange}
              numberOfMonths={1}
              disabled={disabled}
              focused={focused}
              required={required}
              screenReaderInputMessage={''}
              displayFormat='dddd, MMMM Do YYYY'
              placeholder={placeholder}
              showClearDate={!disabled}
              hideKeyboardShortcutsPanel={true}
            />,
            <Label key="label" className={(labelClassName + ' date-label ' + (focused ? ' focused ' : undefined))}>
              {label}
            </Label>,
            !date && <Icon key="icon"
              className='drop-down-arrow'
              width='6'
              height='4'
              viewBox="0 0 6 4"
              name='drop-down-arrow'
            />
          ])}
      </Wrapper>
    );
  }
}

export default Date;



// WEBPACK FOOTER //
// ./src/components/InputField/Date.js